module.exports = __webpack_public_path__ + "img/btn_accept.3742adaa.svg";